import fetchFromApiServer from 'services/api';

export function fetchDocuments(requestObject) {
  const url = `/funddocument-page/fund-document`;
  return fetchFromApiServer('GET', url, requestObject);
}

export function reprocessFundDocument(requestObject) {
  const url = `/funddocument-page/reprocess-document`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function changeDocumentType(requestObject) {
  const url = `/funddocument-page/change-document-type`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function changeBatchDocumentsType(requestObject) {
  const url = `/funddocument-page/change-batch-document-type`;
  return fetchFromApiServer('POST', url, requestObject);
}
